var Component = require("!../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1334fdd7\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MentoringOldWomanIcon.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/oldwoman/MentoringOldWomanIcon.vue
// module id = 797fb173cf910a8cb2f3
// module chunks = 89